<template>
    <div class="option_popup">
        <ul>
            <li><a @click.stop="removeUserPopup">{{ data.oUser.strNickName }}</a></li>
            <li>
                <a @click.stop="memberBlock(data.oUser.nUserNum)">
                    {{ (data.oUser.strBlockCode == 'Y') ? '차단해제' : '게시글 차단' }}
                </a>
            </li>
            <li><a @click.stop="myBoardWriteSlideView(data.oUser.nUserNum)">작성글보기</a></li>
        </ul>
    </div>
</template>

<script>

    export default {
        name: 'boardUserPopup',
        data() {
            return {
            }
        },
        props: ['data'],
        // 계산된 속성
        computed: {
        },
        // 감시자
        watch: {
        },
        // $el 생성전
        created() {
        },
        // $el 생성후
        mounted() {
        },
        methods: {

        },
    }
</script>
<style scoped>

</style>
